import upperFirst from 'lodash/upperFirst'
import { formatUserName } from './formatUserName'
import { User } from './types'

// agentName is the resolved "Omnea AI" name (the helper has no translator, so the caller supplies
// it). Required when isAgent so an agent author can never silently fall through to the user name.
type GetCommentAuthorNameArgs = {
  user: (Pick<User, 'firstName' | 'lastName'> & { isArchived?: boolean }) | null
  integration?: string
  includeInactiveTag?: boolean
} & ({ isAgent: true; agentName: string } | { isAgent?: false; agentName?: never })

export const getCommentAuthorName = (args: GetCommentAuthorNameArgs): string => {
  if (args.isAgent) return args.agentName
  const { user, integration, includeInactiveTag = false } = args
  if (user) {
    const { firstName, lastName, isArchived } = user
    return includeInactiveTag && isArchived !== undefined
      ? formatUserName({ firstName, lastName, isArchived })
      : `${firstName} ${lastName}`
  }
  if (integration) return upperFirst(integration)
  return 'Omnea'
}
